/* 🤖 this file was generated by svg-to-ts*/
export const iconFlashProfile = {
  name: 'flashprofile',
  data: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="14" cy="14" r="14" fill="url(#paint0_linear_250_374)" fill-opacity="0.15"/>
  <path d="M13.0764 22.2103V16.4551H9.56826C9.08028 16.4551 8.75057 15.899 8.98796 15.4403L13.8414 5.4728C14.1447 4.81943 15.0811 5.05575 15.0811 5.79254V11.6173H18.431C18.919 11.6173 19.2355 12.1595 19.0245 12.6182L14.3294 22.5162C14.0128 23.1835 13.0764 22.9471 13.0764 22.2103Z" fill="url(#paint1_linear_250_374)"/>
  <defs>
  <linearGradient id="paint0_linear_250_374" x1="3.5" y1="3.12924e-07" x2="24.5" y2="28" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FFBF1A"/>
  <stop offset="1" stop-color="#FF4080"/>
  </linearGradient>
  <linearGradient id="paint1_linear_250_374" x1="10.1819" y1="5.09088" x2="23.6031" y2="15.3165" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FFBF1A"/>
  <stop offset="1" stop-color="#FF4080"/>
  </linearGradient>
  </defs>
  </svg>
  `,
}
